var map = {
	"./page1.png": 4271,
	"./page10.png": 3542,
	"./page11.png": 1631,
	"./page12.png": 8068,
	"./page13.png": 4221,
	"./page14.png": 2658,
	"./page2.png": 7335,
	"./page3.png": 1550,
	"./page4.png": 6113,
	"./page5.png": 7720,
	"./page6.png": 6051,
	"./page7.png": 6218,
	"./page8.png": 9101,
	"./page9.png": 5860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7310;